import { SettingsSvg } from "@cd/sdds-common-components-react";
import { RedirectSvg } from "@cd/sdds-common-components-react/lib/esm/components/assets";
import React, { forwardRef } from "react";

type MapFabsProps = {
  settingsOpen: boolean;
  onToggleSettings: () => void;
  isFullscreen: boolean;
  onToggleFullscreen: () => void;
};

export const MapFabs = forwardRef<HTMLButtonElement, MapFabsProps>(
  ({ settingsOpen, onToggleSettings, isFullscreen, onToggleFullscreen }, gearBtnRef) => {
    return (
      <div className="map-fabs">
        <button
        id="ch-map-settings"
          type="button"
          ref={gearBtnRef}
          className="map-settings-btn"
          onClick={onToggleSettings}
          aria-controls="map-controls"
          aria-expanded={settingsOpen}
          title="Map settings"
        >
          <SettingsSvg />
        </button>

        <button
          id="ch-map-resize"
          type="button"
          className="fab"
          onClick={onToggleFullscreen}
          aria-pressed={isFullscreen}
          title={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
        >
          <RedirectSvg />
        </button>
      </div>
    );
  }
);
